import { render } from "./GrupoEtareo.vue?vue&type=template&id=167d303e&scoped=true"
import script from "./GrupoEtareo.vue?vue&type=script&lang=js"
export * from "./GrupoEtareo.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=167d303e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167d303e"]])

export default __exports__